import { API_CTX } from '@/config';
import { restoreURL } from '@/lib/axios';

import { AuthUser } from '../types';

export const getUser = (): Promise<AuthUser> => {
  return restoreURL().get(`${API_CTX}/users/me`);
};
